import {selectTaskManagement} from '../../selectors'
import {createSelector} from 'reselect'
import {ColumnTitlesKeys} from './constants'
import messageResource from '../../../messageResource'

export const getColumnsConfiguratorMenuState = (state) => selectTaskManagement(state).columnConfiguratorMenu

export const getColumnsOrder = (state) => getColumnsConfiguratorMenuState(state).columnsOrder

export const getSelectedColumns = (state) => getColumnsConfiguratorMenuState(state).columnsSelected

export const getColumnsForConfigMenu = createSelector(
    getColumnsOrder,
    getSelectedColumns,
    (order, shown) => {
        return order.map((column) => ({
            id: column,
            name: messageResource.getMessage(ColumnTitlesKeys[column]),
            selected: !!shown[column],
        }))
    }
)


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/selectors.js